import type { JSX } from "react";
import { api } from "../api.js";
import { Button } from "../components/ui/button.js";
import { Card } from "../components/ui/card.js";

export function Login(): JSX.Element {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-sm items-center gap-3 p-8 text-center">
        <h1 className="text-2xl font-semibold">Finance OS</h1>
        <p className="text-muted-foreground text-sm">Sign in with your Google account.</p>
        <Button asChild className="mt-2">
          <a href={api.loginUrl}>Sign in with Google</a>
        </Button>
      </Card>
    </div>
  );
}
